import React from 'react';
import { Price, Typography } from 'fronton-react';
import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { getTextColor } from './helpers';
import { PriceBlock } from '../../../styles';

type TProps = {
  isDisable: boolean;
  counter: number;
  product: TComplimentaryProductInfo;
};

export const ComplimentaryBlockPrice = ({ isDisable, counter, product }: TProps) => {
  const totalPrice = product.salesPriceValueInConsumerUnitValue
    ? product.salesPriceValueInConsumerUnitValue * counter
    : 0;
  const textColor = getTextColor(isDisable);
  return (
    <PriceBlock>
      <Price
        color={textColor}
        align="center"
        size="l"
        units={counter > 1 ? '₽' : `₽ / шт.`}
        value={totalPrice}
        variant="medium"
      />
      {counter > 1 && product?.salesPriceValueInConsumerUnitValue ? (
        <Typography size="caption" variant="minor" color={textColor}>
          {`${product.salesPriceValueInConsumerUnitValue} ₽ / шт.`}
        </Typography>
      ) : null}
    </PriceBlock>
  );
};
